const collectionCtrl = class collectionCtrl {
    constructor() {}
}
export default collectionCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/taxFilling/collectionExport/controller/collecitonCtrl.js